import type { ResultOf } from '@graphql-typed-document-node/core';

import Box from '@mui/material/Box';

import { getFragmentData, graphql } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { NoData } from '../../../../components/Illustrations/NoData';
import { useReferencesContext } from '../../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { DataGrid } from '../../../../components/DataGrid';

import { getColumns } from './get-columns';
import { getRowId } from './utils/get-row-id.util';
import { useInitialGridState } from './hooks/useInitialGridState.hook';

export const MaterialPage_CostUsagesList_CostUsage_Fragment = graphql(`
  fragment MaterialPage_CostUsagesList_CostUsage_Fragment on CostUsage {
    _id
    cost {
      _id
      code
      label
      statusId
    }
    index
    quantity {
      value
      unitId
    }
  }
`);

export type MaterialPage_CostUsagesList_CostUsage = ResultOf<
  typeof MaterialPage_CostUsagesList_CostUsage_Fragment
>;

interface Props {
  readonly costUsages: readonly FragmentType<
    typeof MaterialPage_CostUsagesList_CostUsage_Fragment
  >[];
}

export const List = ({ costUsages: pCostUsages }: Readonly<Props>) => {
  const costUsages = getFragmentData(
    MaterialPage_CostUsagesList_CostUsage_Fragment,
    pCostUsages,
  );

  const { genericStatuses } = useReferencesContext();

  const { initialGridState } = useInitialGridState();

  return !costUsages.length ? (
    <NoData />
  ) : (
    <Box sx={{ flexGrow: 1, width: '100%', pt: 2 }}>
      <DataGrid
        columns={getColumns(genericStatuses)}
        getRowId={getRowId}
        initialState={initialGridState}
        rows={costUsages}
      />
    </Box>
  );
};
